import React, { useContext, useEffect } from 'react'
import { ConnectorViewMappingContext } from './context/context'
import ConnectorMappingForm from './ConnectorMappingForm'
import ConnectorImage from './ConnectorImage'
import { NavContext } from '../../../context/global_context'
import { useParams } from 'react-router-dom'
import { getRequest } from '../../../services/base'

const ConnectorMapping = (props) => {
  const { vehicle, connector_view } = useParams()
  const [state, dispatch] = useContext(ConnectorViewMappingContext)
  const [navState, navDispatch] = useContext(NavContext)

  useEffect(() => {
    navDispatch({
      type: 'header',
      data: {
        header: vehicle,
        sub_header: 'Edit Vehicle View',
        id: '',
        show_back_btn: true,
        dtc_details: {},
        vehicle: vehicle,
        back_btn_url: `/vehicles/${vehicle}/connector_views/`,
        full_width_container: true,
      },
    })
    getConnectorViewData()
  }, [])

  const getConnectorViewData = async () => {
    navDispatch({
      type: 'loader',
      data: {
        caption: 'Fetching Connector Views Data',
        showLoader: true,
      },
      notification: {},
    })

    let res = await getRequest(`/api/connector_views/${connector_view}/`)
    dispatch({ type: 'connector_view', data: res })
    navDispatch({
      type: 'loader',
      data: {
        caption: '',
        showLoader: false,
      },
      notification: {},
    })
  }

  return (
    <div
      className="flex flex-grow stretch-items overflow-hidden"
      style={{ height: 'calc(100vh - 64px)' }}
    >
      <ConnectorMappingForm />
      <ConnectorImage />
    </div>
  )
}

ConnectorMapping.propTypes = {}

export default ConnectorMapping
